import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import staticTranslations from '../staticTranslations.json';

const resources = {
  en: {
    translation: staticTranslations.en
  },
  it: {
    translation: staticTranslations.it
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "it",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: [
        "path",
        "querystring",
        "navigator",
        "cookie",
        "localStorage",
        "sessionStorage",
        "htmlTag",
        "subdomain",
      ],
      caches: ['localStorage', 'cookie'], // Optionally ensure the plugin caches the detected language
    },
  });

export const updateMetaTags = (t) => {
  document.title = t('title');

  const descriptionTag = document.querySelector('meta[name="description"]');
  if (descriptionTag) {
    descriptionTag.setAttribute("content", t('description'));
  }

  const keywordsTag = document.querySelector('meta[name="keywords"]');
  if (keywordsTag) {
    keywordsTag.setAttribute("content", t('keywords'));
  }

  const ogTitleTag = document.querySelector('meta[property="og:title"]');
  if (ogTitleTag) {
    ogTitleTag.setAttribute("content", t('og:title'));
  }

  const ogDescriptionTag = document.querySelector('meta[property="og:description"]');
  if (ogDescriptionTag) {
    ogDescriptionTag.setAttribute("content", t('og:description'));
  }

  const twitterTitleTag = document.querySelector('meta[property="twitter:title"]');
  if (twitterTitleTag) {
    twitterTitleTag.setAttribute("content", t('twitter:title'));
  }

  const twitterDescriptionTag = document.querySelector('meta[property="twitter:description"]');
  if (twitterDescriptionTag) {
    twitterDescriptionTag.setAttribute("content", t('twitter:description'));
  }
};

export default i18n;
